export const IDENTIFIER_KEY = 'identifier';
export const TYPENAME_KEY = '__typename';
export const SYS_KEY = 'sys';
export const UNDEFINED = 'undefined';
export const REDIS_APP_KEY_PREFIX = 'app-';
export const REDIS_PMC_APP_KEY_PREFIX = 'app';
export const REDIS_SEO_APP_KEY_PREFIX = 'app-seo-';
export const REDIS_HOMEPAGE_KEY = 'homepage';
